'use client'
import Link from "next/link"

import { useRef,useEffect } from "react";

/**
 * Ce composant affiche un élément du calendrier et retourne vers la page de l'évènement adéquat.
 * @param {object} parametter - Paramètre du composant
 * @param {string} parametter.title - Titre de l'évènement
 * @param {number} parametter.day - Jour du mois dureant lequel déroule l'évenement
 * @param {string} parametter.mount - Mois durant lequel se déroule l'événement
 * @param {boolean} parametter.isFull - Indique si l'événement est plein.
 * @param {string} parametter.fullText - Text de la bannière lorsque l'événement est plein.
 * @param {string|number} parametter.id - ID de l'événement dans la base de donnée.
 * @param {object} parametter.local - Dictionnaire du site web.
 * @param {'fr'|'en'|'nl'} parametter.lang - Langue du site web
 * @returns 
 */
export default function CalendarCard({title,day,mount,isFull,fullText,id,lang,local,disabled = false}){

    const item = useRef(null); // Référence à l'élément HTML

    useEffect(() => {
        // Création de l'observateur
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Si l'élément entre dans la zone définie (viewport)
                    item.current.classList.remove("scale-75");
                } else {
                    // Si l'élément sort de la zone définie
                    item.current.classList.add("scale-75");
                }
            });
        }, {
            // Ajuste la zone d'observation (marge du viewport)
            root: null, // viewport entier
            rootMargin: "0px", // pas de marge
            threshold: 0.8, // déclenchement lorsque 50% de l'élément est visible
        });

        const element = item.current;
        if (element) observer.observe(element);

        // Nettoyage pour éviter des fuites de mémoire
        return () => {
            if (element) observer.unobserve(element);
        };
    }, []);

    return(
        <div className="size-full">
            <Link className="hidden  bg-white lg:block overflow-hidden relative ubuntu text-[#000066] text-center rounded-lg shadow-xl cursor-pointer size-full group" href={disabled ? "#": `/${lang}/${local.staticPage.agenda}/${id}/${title}`}>
                {
                    isFull &&
                    <div className=" origin-center group-hover:bg-white group-hover:text-[#000066] transition-all duration-1000 px-2 py-0.5 rounded-t-lg left-[30%] top-[10%] rotate-[40deg]  absolute w-full lora text-white font-bold bg-[#000066]">
                        {fullText}
                    </div>
                }
                <div className="bg-white h-full" >
                    <div className="h-[65%] flex flex-col group-hover:bg-[#000066] group-hover:text-white transition-all duration-1000">
                        <div className="my-auto pt-12 group-hover:pt-0  transition-all duration-1000">
                            <p className="text-6xl font-bold ">{day < 10 ? `0${day}` : day}</p>
                            <p className="self-end text-lg font-bold py-0 ">{mount}</p>
                        </div>
                    </div>
                    <div className="h-[35%] w-full flex pb-12 group-hover:pb-0 transition-all duration-1000">
                        <p className="my-auto px-4 text-sm w-full">{title}</p>
                    </div>
                </div>
                
            </Link>
            <Link ref={item} className="bg-white scale-75 transition all lg:hidden relative ubuntu text-[#000066] grid text-center rounded-lg shadow-xl cursor-pointer size-full group relative my-auto aspect-square" href={disabled ? "#": `/${lang}/${local.staticPage.agenda}/${id}/${title}`}>
                {
                    isFull &&
                    <div className=" px-2 py-0.5 text-[0.7vw] rounded-t-lg left-20 top-10 rotate-45 absolute w-full lora text-white font-bold bg-[#B8D5FD]">
                        {fullText}
                    </div>
                }
                <div className="my-auto py-4" >
                <div className="text-center">
                    <p className="text-[30px] px-4 py-0 font-bold ">{day}</p>
                    <p className="self-end text-[18px] px-4 font-bold py-0 ">{mount}</p>
                    <p className="text-[13px]">{title}</p>
                    </div>
                </div>
                
            </Link>
        </div>

    )
    
}